<template>
  <section class="section-activity" v-if="links.length > 0">
    <span class="label-card">REPOSITORIO (VIDEOS)</span>
    <v-list class="mt-1">
      <div
        v-for="link in links"
        v-bind:key="link.id"
        class="lighten-4 mb-1 repo-link"
      >
        <v-list-tile @click="linkTo(link.url, link.id)" avatar>
          <v-list-tile-avatar>
            <div class="avatar-p">
              <i style="font-size: 15px;" class="pi pi-external-link"></i>
            </div>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <div
                class="p-text-nowrap secondaryText--text"
                style="width: 3rem"
              >
                <p class="body-1">{{ link.nombre }}</p>
              </div>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <Checkbox
          class="p-ml-4"
          v-model="checks"
          :value="checks.find(e => e.link_id === link.id) || { link_id: link.id }"
          :disabled="true"
        />
      </div>
    </v-list>
  </section>
</template>
<script>
import { mapState } from "vuex";
import checkService from "@/services/axios/check.service";
export default {
  props: {
    links: {
      type: Array,
      required: true
    },
    links_check: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      checks: []
    };
  },
  mounted() {
    this.checks = [...this.links_check];
  },
  computed: {
    ...mapState({
      currentLesson: state => state.navigation.currentLesson
    })
  },
  methods: {
    toogleLinkCheck(linkId) {
      const status = this.checks.some(e => e.link_id === linkId);
      if (!status) {
        this.createLinkCheck(linkId);
      }
    },
    createLinkCheck(linkId) {
      checkService
        .createLinkCheck({
          lesson_id: this.currentLesson.id,
          link_id: linkId
        })
        .then(({ data }) => {
          this.checks = data;
        });
    },
    deleteLinkCheck(linkId) {
      checkService.deleteLinkCheck(linkId).then(({ data }) => {
        this.checks = data;
      });
    },
    linkTo(url, linkId) {
      window.open(`${url}`, "_blank");
      this.toogleLinkCheck(linkId);
    }
  }
};
</script>

<style scoped>
.section-activity {
  background-color: white;
  border: 1px solid #dee2e6;
  padding: 1rem;
  border-radius: 3px;
  display: flex;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  flex-direction: column;
}
.avatar-p {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  width: 40px;
  height: 40px;
  background-color: #00897b;
  border-radius: 50%;
}
.repo-link {
  display: flex;
  align-items: center;
}
.repo-link li {
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Leccion/LessonLinks.vue